exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "* {\n    user-select: none;\n    -webkit-user-select: none;\n}\n\ninput, textarea {\n    -webkit-user-select: text;\n}\n", ""]);
